import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { EmptyState } from '@/components/states';

export function NotFoundPage(): JSX.Element {
  return (
    <>
      <Card>
        <EmptyState
          icon={<Compass className="size-5" aria-hidden />}
          title="There is nothing at this address"
          description="The link may be out of date, or the screen may not exist yet."
          action={
            <Button asChild variant="outline">
              <Link to="/">Back to the dashboard</Link>
            </Button>
          }
        />
      </Card>
    </>
  );
}
